import { Indicator } from '../../../Common/Charts/Indicator';
import useIndicatorChart from './hooks/useIndicatorChart';

export const IndicatorProd = () => {
    const { value } = useIndicatorChart();

    return (
        <Indicator
            title={`Índice de Eficácia - Quantidade`}
            indicatorValue={value}
        />
    );
};
